konnyScript(function($) {
	//gif 
	const swiperMap = new WeakMap();

	const initSwiper = (el) => {
		if (swiperMap.has(el)) return;
		const instance = new Swiper(el, {
		spaceBetween: 0,
		effect: 'fade',
		speed: 800,
		loop: true,
		autoplay: {
			delay: 1000,
			disableOnInteraction: false,
		},
		});
		swiperMap.set(el, instance);
	};

	const io = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
		const el = entry.target;
		const inst = swiperMap.get(el);

		if (entry.isIntersecting) {
			initSwiper(el);
			swiperMap.get(el)?.autoplay?.start();
		} else {
			inst?.autoplay?.stop();
		}
		});
	}, { threshold: 0.3 });

	document.querySelectorAll('.gifSwiper').forEach((el) => io.observe(el));
	

	// 감사제 특별가격
	let specialPriceTopSlide = null;
	let specialPriceBtSlide  = null;

	function ensureTopVisible(index, speed = 300) {
		if (!specialPriceTopSlide) return;
		try { specialPriceTopSlide.update(); } catch (e) {}
		requestAnimationFrame(() => {
			try { specialPriceTopSlide.slideTo(index, speed); } catch (e) {}
		});
	}

	$(function () {
function syncSpecialPriceLink(i){
		const $a=$('#specialPriceTop_slide .specialPriceBtn').eq(i);
		let n=$a.attr('data-product-no')||$a.find('[data-product-no]').attr('data-product-no');
		const $b=$('#specialPriceTop_slide .btn a');
		if(!n)return $b.removeAttr('href');
		$b.attr('href',/^https?:\/\//.test(n)?n:'/product/detail.html?product_no='+n);
		}

		specialPriceTopSlide = new Swiper('#specialPriceTop_slide', {
			slidesPerView: 3,
			spaceBetween: 10,
			grabCursor: true,
			centeredSlides: false,

			observer: true,
			observeParents: true,
			observeSlideChildren: true,

			on: {
				init: function () {
					const idx = this.realIndex || 0;
					requestAnimationFrame(() => syncSpecialPriceLink(idx));
					ensureTopVisible(idx, 0);
				}
			}
		});

		const btEl = document.querySelector('#specialPriceBt_slide');
		if (!btEl) return;

		const onIntersect = (entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					if (!specialPriceBtSlide) {
						specialPriceBtSlide = new Swiper('#specialPriceBt_slide', {
							slidesPerView: 1,
							slidesPerGroup: 1,
							effect: 'fade',
							centeredSlides: false,
							autoplay: {
								delay: 1700,
								disableOnInteraction: false,
							},
							scrollbar: {
								el: '#specialPriceTop_slide .swiper-scrollbar',
								hide: false,
							},
							on: {
								init: function () {
									try { this.autoplay?.stop?.(); } catch (e) {}
								},
								activeIndexChange: function () {
									const i = this.realIndex;

									$('#specialPriceTop_slide .specialPriceBtn')
										.removeClass('on')
										.eq(i).addClass('on');

									ensureTopVisible(i);
									syncSpecialPriceLink(i);
								}
							}
						});
					}
					try { specialPriceBtSlide.autoplay?.start?.(); } catch (e) {}
				} else {
					if (specialPriceBtSlide) {
						try { specialPriceBtSlide.autoplay?.stop?.(); } catch (e) {}
					}
				}
			});
		};

		const swiperObserver = new IntersectionObserver(onIntersect, { threshold: 0.5 });
		swiperObserver.observe(btEl);

		$('#specialPriceTop_slide button').on('click', function () {
			const i = $(this).closest('.swiper-slide').index();

			ensureTopVisible(i);
			if (specialPriceBtSlide) {
				try { specialPriceBtSlide.slideTo(i); } catch (e) {}
			}
			$(this).closest('.swiper-slide').addClass('on').siblings().removeClass('on');
			syncSpecialPriceLink(i);
		});
	});
    
    $('[id^=\'bw_prd_swiper_slide\']').each(function(index){
		index = index+1;
		var slidePage1 = '#bw_prd_swiper_slide'+index+' .swiper-pagination';
		var slidePage2 = '#bw_prd_swiper_slide'+index+' .swiper-progress';
		var slideScr = '#bw_prd_swiper_slide'+index+' .swiper-scrollbar';
		var slideNext = '#bw_prd_swiper_slide'+index+' .swiper-button-next';
		var slidePrev = '#bw_prd_swiper_slide'+index+' .swiper-button-prev';
		var bwPrdSlide = new Swiper(this,{
			slidesPerView: 3,
			slidesPerGroup: 1,
			spaceBetween: '1.6%',
			pagination:true,
			pagination:{
					el:slidePage2,
					type : 'progressbar'
			},
			scrollbar:{
					el:slideScr,
					hide:true,
			},
			navigation: {
					nextEl: slideNext,
					prevEl: slidePrev,
			},
		});
    });
}); 